<template>
  <help-sidebar :localised-path>
    <template #sidebar-title="{ id }" v-if="$feature.enableLanguagePreference && route.path.includes('-es')">
      <h2 :id class="mb-4 title-2">
        Centro de Ayuda
      </h2>
    </template>
  </help-sidebar>
</template>

<script lang="ts" setup>
import HelpSidebar from '#commerce/components/help/Sidebar.vue'

defineProps<{
  localisedPath?: string
}>()

const route = useRoute()
</script>
